import React, {Component} from "react";
import {  Row, Col, ListGroup, ListGroupItem, Modal, ModalHeader, ModalBody, ModalFooter, Progress, Collapse, CardBody, UncontrolledTooltip, Button } from "reactstrap";
import { post } from "axios";
import { withRouter } from "react-router";
import "react-toggle/style.css"; 
import Toggle from "react-toggle";
import moment from "moment";
import JSMpeg from "jsmpeg-player";
import Proptypes from "prop-types";
import "rc-slider/assets/index.css";
import { connect } from "react-redux";
import Slider,{createSliderWithTooltip} from "rc-slider";
import { NotificationManager } from "react-notifications";
import stopReload from "../../constants/Constants";
import { destroyKasmShareId, createKasmShareId} from "../../actions/actionDashboard";
import ChatComponent from '../Chat/ChatComponent';

var player;
var keepAlive;       
var renderNav; 

class ViewPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            showNav: false,
            audio: true,
            collapse: false,
            currentIndex: null,
            shareLink: null,
            message: null,
            disableIndex: [],
            modalAdvanced: false,
            firstClick: false,
            logoutAll: false,
        };

        this.showNav = this.showNav.bind(this);
        this.hideNav = this.hideNav.bind(this);
        this.toggleNav = this.toggleNav.bind(this);
        this.confirmLogout = this.confirmLogout.bind(this);
        this.cancelLogout = this.cancelLogout.bind(this);
        this.showLogout = this.showLogout.bind(this);
        this.toggleLogout = this.toggleLogout.bind(this);
        this.toggle = this.toggle.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.handleAudioChange = this.handleAudioChange.bind(this);
        this.destroyAudio = this.destroyAudio.bind(this);
        this.connectAudio = this.connectAudio.bind(this);
        this.receiveMessage = this.receiveMessage.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.onUnlocked = this.onUnlocked.bind(this);
        this.reSyncAudio = this.reSyncAudio.bind(this);
        this.updateLogoutAll = this.updateLogoutAll.bind(this);
    }

    handleAudioChange(e){
        let value = e.target.checked;
        value ? this.connectAudio() : this.destroyAudio();
        this.setState({
            audio: value
        });
    }

    showLogout(){
        this.setState({
            modal: true,
            showNav: false
        });
    }

    confirmLogout(){
        this.toggleLogout();
        window.removeEventListener("beforeunload", stopReload, true);
        let logout_data = {logout_all: this.state.logoutAll};
        this.props.logout(logout_data);
    }

    componentDidMount(){
        this.props.statusKasms.share_id && this.setState({shareLink: this.props.statusKasms.share_id});

        if (this.props.disconnect) {
            this.setState({showNav: false});
        }

        if (window.addEventListener) {
            window.addEventListener("message", this.receiveMessage, false);
        } else if (window.attachEvent) { 
            window.attachEvent("message", this.receiveMessage);
        }  
        this.setState({modal: false});

        // Add audio for when the domain already allows audio and add event listener to re establish audio on first
        // click to resolve sync problems
        if (this.props.statusKasms.client_settings && this.props.statusKasms.client_settings.allow_kasm_audio
            && this.props.statusKasms.client_settings.kasm_audio_default_on) {
            this.connectAudio();
            window.addEventListener("mousedown", this.reSyncAudio);
            window.addEventListener('touchstart', this.reSyncAudio, false);
        } else {
            this.setState({firstClick: true})
        }

        window.addEventListener("blur",() => {  
            renderNav = setTimeout(() => {
                if (document.activeElement.id instanceof HTMLIFrameElement) {
                    this.hideNav();
                }
            }, 10);
        });
    }

    onUnlocked () {
        if (typeof player !== undefined) {
            player.volume = 1;
        }
    }

    reSyncAudio() {
        window.removeEventListener("mousedown", this.reSyncAudio);
        window.removeEventListener('touchstart', this.reSyncAudio);
        this.destroyAudio();
        this.connectAudio();
    }

    connectAudio(){
        const{statusKasms}=this.props;
        const audio_url = `wss://${statusKasms.hostname}:${statusKasms.port_map.audio.port}/${statusKasms.port_map.audio.path}/`;
        this.setState({audio_url});
        var canvas = document.getElementById("video-canvas");
        player = new JSMpeg.Player(audio_url, {canvas: canvas});

        // mobile Fix: try to unlock immediately
        if (player && player.audioOut) {
            player.audioOut.unlock(this.onUnlocked);
        }
    }

    destroyAudio() {
        if (typeof player !== undefined)
            try {
                player.destroy();
            } catch (err) {
                console.log(err);
                player = null;
            }
    }

    componentWillUnmount(){
        this.destroyAudio();
        clearInterval(keepAlive);
        clearInterval(renderNav);
        window.removeEventListener('touchstart', this.reSyncAudio);
        window.removeEventListener("mousedown", this.reSyncAudio);
    }

    cancelLogout(){
        this.toggleLogout();
        this.props.history.push("/");
    }

    showNav(){
        this.setState({ showNav: true });
    }

    hideNav(){
        this.setState({ showNav: false });
    }

    toggleNav(){
        this.setState({ showNav: !this.state.showNav });
    }

    toggleLogout(){
        this.setState({ modal: !this.state.modal });   
    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    handleClose(e) {
        this.props.history.push("/")
    }

    receiveMessage(event) {
        if (event.data && event.data.action == "clipboardrx")
            this.setState({clipboardText: event.data.value });
        else if (event.data && event.data.action == "disconnectrx" && !this.state.destroyClicked) {
            this.props.handleDisconnect();
        } else if ( event.data.action == "togglenav")
            this.toggleNav();
        else if ( event.data.action == "idle_session_timeout") {
            window.removeEventListener("beforeunload", stopReload, true);
            this.props.logout();
        } else if (event.data.action == "firstClick") {
            if (!this.state.firstClick)
                this.reSyncAudio();
            this.setState({firstClick: true});
        } else if (event.data.action == "firstTouch") {
            if (!this.state.firstClick)
                this.reSyncAudio();
            this.setState({firstClick: true});
        }
    }

    showMessage(i){
        const {fileStatusArr} = this.state;
        let element = "";

        element = fileStatusArr.find(function(element) {return element.index === i;});

        if(element){
            if(element && element["success-status"]){
                return  <span className="text-success blk_inline mt-7"> {element["success-status"]} </span>;
            }
            else if(element && element["failure-status"]){
                return  <span className="text-danger blk_inline mt-7"> {element["failure-status"]} </span>;
            }            
        }
        return  " ";
    }

    copyToClipboard(str) {
        const el = document.createElement('textarea');
        el.value = str
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    openWindow(url){
        window.open(url, "_blank", "resizable=yes,top=0,left=0,width=800,height=640");
    }

    updateLogoutAll() {
        this.setState({logoutAll: !this.state.logoutAll});
    }

    render() {
        const {statusKasms} = this.props;
        const userInfo = JSON.parse(window.localStorage.user_info);
        const navOverride = this.props.hideViewPanel ? {display : "None"} : {};

        // Send an event to the parent document (kasm app) to toggle the control panel when ctl is double clicked
        var delta = 500;
        var lastKeypressTime = 0;
        if (this.props.toggle_control_panel === true) {
            document.addEventListener('keyup', (event) => {
                const keyName = event.key;
                // CTRL and the various implementations of the mac command key
                if ([17, 224, 91, 93].indexOf(event.keyCode) > -1) {
                    let thisKeypressTime = new Date();
                    if (thisKeypressTime - lastKeypressTime <= delta) {
                        this.toggleNav();
                        thisKeypressTime = 0;
                    }
                    lastKeypressTime = thisKeypressTime;
                }
            }, true);
        }
        return (
            <div>
                <canvas id="video-canvas"/>
                <i id="nav_toggle" className="fa fa-ellipsis-v toggle_icon" onClick={this.showNav} aria-hidden="true" style={navOverride}/>
                {statusKasms &&
                    <div id="mySidenav" className={this.state.showNav && !this.props.hideViewPanel ?  "sidenav show_nav" : "sidenav hide_nav"}   >
                        <a href="javascript:void(0)" className="fa fa-close closebtn" onClick={() => this.hideNav()} />
                        <a className="sidenav3 sidenav-general toggle_nav" data-target="#collapseExample" onClick={this.toggle}>
                            <i className = "fa fa-desktop" aria-hidden="true"></i>  Kasm ID : <span> {statusKasms && statusKasms.kasm_id.substring(0, 6)}</span>
                            <span style = {{ "visibility" : "hidden" }} >  Connection Strength : </span><span  style = {{ "visibility" : "hidden" }} >Poor  </span>
                            <i style= {{color : "Red", "visibility" : "hidden" }} className="fa fa-signal"></i>
                            <span>
                            <button className="btn btn-dark btn-sm"  onClick={() => this.handleClose()}> Home</button>
                            <button className="btn btn-dark btn-sm"  onClick={() => this.showLogout()}> Logout</button>
                            </span>
                            <span className="toggle_arrow_icon">
                                { this.state.collapse ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"> </i> }
                            </span>
                        </a>

                        <Collapse isOpen={this.state.collapse} id="collapseExample" className="toggle_panel para_border">
                            <CardBody>
                                <p> <span>User</span> {userInfo.username}</p>
                                <p> <span>Image</span> {statusKasms.image.friendly_name}</p>
                                <p> <span>Expiration</span> {moment.utc(moment.utc(statusKasms.expiration_date).diff(moment.utc(statusKasms.current_time), "hh:mm" )).format("HH:mm")}</p>
                                <p> <span>URL</span>
                                    <button className="btn btn-link p-0" onClick={() => {this.openWindow("https://" + window.location.host + window.location.pathname +  "#/join/" + statusKasms.share_id)}} >{"https://" + window.location.host + window.location.pathname  + "#/join/" + statusKasms.share_id}</button>
                                    <button className="btn btn-default btn-sm" onClick={() => {this.copyToClipboard("https://" + window.location.host + window.location.pathname  + "#/join/" + this.props.statusKasms.share_id)}}><i className = "fa fa-copy" aria-hidden="true"></i></button>
                                </p>
                            </CardBody>
                        </Collapse>

                        {statusKasms.client_settings.allow_kasm_audio == true ?
                            <a className="sidenav3 sidenav-general"> <i className="fa fa-volume-up" aria-hidden="true"/> Audio
                                <label>
                                    <Toggle
                                        onChange={this.handleAudioChange}
                                        defaultChecked={this.props.statusKasms.client_settings.kasm_audio_default_on}/>
                                </label>
                            </a>
                            : <a className="sidenav1 sidenav-general toggle_nav"> <i className="fa fa-volume-up"
                                                                                     aria-hidden="true"></i> <span
                                className="disable_txt">Audio</span> <span
                                style={{"color": "#f2a025", "marginLeft": "30px", "fontWeight": "bold"}}> Disabled by Administrator </span>
                                <label> <Toggle checked={false}/> </label> </a>
                        }
                    </div>}


                <Modal zIndex={999999} isOpen={this.state.modal} toggle={this.toggleLogout} >
                    <ModalHeader toggle={this.toggleLogout}>Logout <i className="fa fa-sign-out" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={{ size: 12}}>
                                <p>Are you sure you want to Logout?</p>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={{ size: 12}}>
                                <label id="force_label" >Logout of all sessions: &nbsp; &nbsp;<input type="checkbox" value={this.state.logoutAll} onChange={this.updateLogoutAll}/></label>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.confirmLogout} size="sm" color="primary"> <i className="fa fa-sign-out"></i> Logout</Button>
                        <Button onClick={this.toggleLogout} size="sm" color="basic"><i className="fa fa-ban"></i> Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}


ViewPanel.propTypes = {
    logout: Proptypes.func.isRequired,
    statusKasms: Proptypes.object,
    history: Proptypes.object,
    kasmId: Proptypes.func,
    videoQuality: Proptypes.number,
    setVideoQuality: Proptypes.func,
    handleDisconnect: Proptypes.func,
    hideViewPanel: Proptypes.bool,
};

ViewPanel = withRouter(ViewPanel); // eslint-disable-line

export default connect(state =>
        ({
            share_id: state.dashboard.share_id || null,
            destroyShareLoading: state.dashboard.destroyShareLoading || null,
            destroyShareError: state.dashboard.destroyShareError || null,
            createShareLoading: state.dashboard.createShareLoading || null,
            createShareError: state.dashboard.createShareError || null,
        }),
    dispatch =>
        ({
            createKasmShareId: (data) => dispatch(createKasmShareId(data)),
            destroyKasmShareId: (data) => dispatch(destroyKasmShareId(data)),
        }))(ViewPanel);



// WEBPACK FOOTER //
// ./src/components/ViewPanel/ViewPanel.js